import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import PaymentsIcon from '@mui/icons-material/Payments';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HomeIcon from '@mui/icons-material/Home';
import StoreIcon from '@mui/icons-material/Store';
import MenuOutlinedIcon from '@mui/icons-material/MenuOutlined';
import StoreMallDirectoryOutlinedIcon from '@mui/icons-material/StoreMallDirectoryOutlined';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';

import {
    GATEWAY_PAYMENT_TOKEN,
    MAX_WIDTH_CONTAINER,
    WALLET_KEY,
} from '../../config/cacheKey';
import {ReactElement, useEffect, useRef, useState} from 'react';
import './bottomNavigation.css';
import LoansContainer from '../../pages/navigationButtonComponents/loansTab/loansContainer';
import Profile from '../../pages/menuTab/profile/profile';
import MenuContainer from '../../pages/menuTab/profile/menuContainer';
import StoreContainer from '../../pages/navigationButtonComponents/walletContainer/storeContainer';
import HomeMenuContainer from '../../pages/navigationButtonComponents/homeTab/homeMenuContainer';
import {getpervStateTab} from '../../redux/loansTab/loansTabSlice';
import {useDispatch, useSelector} from 'react-redux';
import {useQuery, useQueryClient} from 'react-query';
import {GetCustomerInfo} from '../../services/customer.service';
import hideElement from '../../utility/hideElement';
import {
    getNextInnerState,
    getNextState,
    getpervInnerState,
} from '../../redux/handleBackBtn/handleBackBtnSlice';
import {RootState} from '../../redux/store';

export default function FixedBottomNavigation() {
    const [value, setValue] = useState<number>(0);
    const ref = useRef<HTMLDivElement>(null);
    const [tabChild, setTabChild] = useState<ReactElement>();
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    const {data: profile, isLoading} = useQuery(
        'customerInfo',
        GetCustomerInfo,
        {
            staleTime: 1000 * 60 * 30,
            cacheTime: 1000 * 60 * 60,
            refetchOnWindowFocus: false,
        }
    );

    queryClient.setQueryData('PROFILE_INFO', {profile, isLoading});
    const prevRoute = useSelector(
        (state: RootState) => state.loansTabComponents.prevState
    );

    useEffect(() => {
        if (prevRoute === 'loans12') {
            setValue(2);
            dispatch(getpervStateTab({prevState: `appContainer`}));
            dispatch(getNextState({nextState: `confirmLoanTemplate`}));
            return;
        }
    }, [prevRoute]);

    useEffect(() => {
        const params = new URLSearchParams(
            new URL(window.location.href).search
        );
        const target = params.get('target');
        queryClient.setQueryData('URL_PARAMS', {
            param: window.location.pathname,
            token: params,
        });
        //route from kaman
        const substrings = ['registerLoan', 'loans', 'requestLoan'];

        if (substrings.some((sub) => target?.includes(sub))) {
            setValue(2);
        } else if (target?.includes('store')) {
            setValue(1);
            dispatch(
                getNextInnerState({nextInnerState: `store ${Math.random()} `})
            );

            // const newCleanUrl = `${window.location.origin}/#/`;
            // window.history.replaceState(null, '', newCleanUrl);
        } else if (target?.includes('wallet')) {
            setValue(1);
            dispatch(
                getNextInnerState({nextInnerState: `wallet ${Math.random()} `})
            );
        } else if (target?.includes('trade')) {
            dispatch(
                getNextInnerState({nextInnerState: `trade ${Math.random()}`})
            );
            const newCleanUrl = `${window.location.origin}/#/`;
            window.history.replaceState(null, '', newCleanUrl);
        } else if (window.location.pathname.includes('installmentPayment')) {
            setValue(2);
            dispatch(getpervStateTab({prevState: 'installment'}));
            const newCleanUrl = `${window.location.origin}/#/`;
            window.history.replaceState(null, '', newCleanUrl);
        } else if (window.location.pathname.includes('OnlinePrePayment')) {
            setValue(2);
            dispatch(getpervStateTab({prevState: 'appContainer'}));
            queryClient.setQueryData('ONLINE_PREPAYMENT', 'onlinePrepayment');
            const newCleanUrl = `${window.location.origin}/#/`;
            window.history.replaceState(null, '', newCleanUrl);
        } else {
            setValue(0);
        }
    }, []);

    useEffect(() => {
        changeTabChild(value, false);
    }, [value]);
    const handleNvigate = (stateRedux: string) => {
        dispatch(getpervStateTab({prevState: stateRedux}));
    };

    const changeTabChild = (numberTab: number, isBtnClick?: boolean) => {
        switch (numberTab) {
            case 0:
                isBtnClick && handleNvigate(`home ${Math.random()}`);
                return setTabChild(
                    <HomeMenuContainer setTabChild={setValue} />
                );
            case 1:
                isBtnClick && handleNvigate(`store ${Math.random()}`);
                queryClient.setQueryData(WALLET_KEY, '');
                return setTabChild(<StoreContainer setTabChild={setValue} />);
            case 2:
                isBtnClick && handleNvigate('loans');
                return setTabChild(<LoansContainer setTabChild={setValue} />);
            case 3:
                isBtnClick && handleNvigate(`profile ${Math.random()}`);
                return setTabChild(<MenuContainer setTabChild={setValue} />);

            default:
                break;
        }
        localStorage.removeItem(GATEWAY_PAYMENT_TOKEN);
    };

    return (
        <Box sx={{pb: 40}} ref={ref}>
            <CssBaseline />
            <List>{tabChild}</List>
            <Paper
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    maxWidth: MAX_WIDTH_CONTAINER,
                    margin: 'auto',
                    zIndex: '1220',
                }}
                id="fixed-bottom-navigation"
                elevation={3}
            >
                <BottomNavigation
                    showLabels
                    value={value}
                    onChange={(event, newValue) => {
                        changeTabChild(newValue, true);
                        setValue(newValue);
                    }}
                    sx={{background: 'var(--input-bg-color)'}}
                >
                    <BottomNavigationAction
                        label="خانه"
                        icon={
                            value === 0 ? (
                                <HomeIcon sx={{color: '#BBA57A'}} />
                            ) : (
                                <HomeOutlinedIcon />
                            )
                        }
                        className="primaryColorLight-100"
                        sx={{
                            fontWeight: 'bold',
                            '& .Mui-selected': {
                                color: '#BBA57A',
                            },
                        }}
                    />
                    <BottomNavigationAction
                        label="بازار"
                        icon={
                            value === 1 ? (
                                <StoreIcon sx={{color: '#BBA57A'}} />
                            ) : (
                                <StoreMallDirectoryOutlinedIcon />
                            )
                        }
                        className="primaryColorLight-100"
                        sx={{
                            fontWeight: 'bold',
                            '& .Mui-selected': {
                                color: '#BBA57A',
                            },
                        }}
                    />
                    <BottomNavigationAction
                        label="تسهیلات"
                        icon={
                            value === 2 ? (
                                <PaymentsIcon sx={{color: '#BBA57A'}} />
                            ) : (
                                <PaymentsOutlinedIcon />
                            )
                        }
                        className="primaryColorLight-100"
                        sx={{
                            fontWeight: 'bold',
                            '& .Mui-selected': {
                                color: '#BBA57A',
                            },
                        }}
                    />
                    <BottomNavigationAction
                        label="منو"
                        icon={
                            value == 3 ? (
                                <MenuOutlinedIcon sx={{color: '#BBA57A'}} />
                            ) : (
                                <MenuOutlinedIcon />
                            )
                        }
                        className="primaryColorLight-100"
                        sx={{
                            fontWeight: 'bold',
                            '& .Mui-selected': {
                                color: '#BBA57A',
                            },
                        }}
                    />
                </BottomNavigation>
            </Paper>
        </Box>
    );
}
